'use strict';

var angular = require('angular');
var $ = require('jquery');
var _ = require('lodash');
var GridPanelDirective = function GridPanelDirective(SortService, SortCriteria, LatestSortService, angularHelper, $compile, $rootScope, $window) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    controller: 'GridPanelController',
    template: require('../templates/grid-panel.html'),
    scope: {
      gridId: '@grid',
      gridTitle: '@',
      mode: '@',
      target: '@',
      screen: '@',
      cogOptionSet: '=',
      cogId: '@',
      customRenderers: '=?',
      rowDetails: '@',
      rowDetailsExpandMultipleRows: '=',
      rowDetailsTemplate: '=?',
      rowDetailsCalculateHeight: '=?',
      loadingCaption: '=?',
      contextMenuItems: '=',
      contextMenuShowWhenOnlyOneRowSelected: '=',
      showSelectionCheckboxes: '=?',
      //indicate if server have sorting. By default true.
      //if false - grid will try sort
      //data on loading from server
      serverSorting: '@',
      //indicate should grid retrieve data on search on not.
      //default value is true
      retrieveDataOnSearch: '=?',
      //indicate should grid retrieve data on initialization on not.
      //default value is true
      retrieveDataOnInit: '=?',
      dynamicColumnTitleFormatter: '=',
      dynamicColumnSorter: '=',
      dynamicColumnsReSort: '=?',
      // render grid dynamically based on provided settings
      dynamicGridSettings: '=?',
      // to distinguish grid settings for grids with same gridId
      dynamicGridSuffix: '=?',
      // instead of retrieving data from server, we populating grid with local data
      localData: '=?',
      filterData: '=',
      cellEditHandler: '=',
      cellClickHandler: '=',
      //If user permissions need to be set for grid-related entities
      userPermission: '@?',
      //If Grid need to be fill extra data before show.
      beforeShowData: '=?',
      //If Grid no need load user settings
      withoutUserSettings: '=?',
      //if grid is in reopt preview mode
      reoptPreviewData: '=?',
      //indicate grid should mantain the filter state.
      keepGridFilteringState: '=?',
      //enable reopt preview
      isDemandManagement: '=?',
      //use livedata mechanism
      //default false
      isLiveData: '=?',
      useTranscludedToolbar: '=',
      confirmAdjustmentsClearOnRefresh: '=?',
      //is toolbar header visible, default true
      isToolbarVisible: '=?',
      // Ask Confirmation before delete any row
      askConfirmationOnDelete: '=?',
      withReadOnlyRuleModal: '=?',
      visibleOffset: '=?',
      visibleOffsetRowHeight: '=?',
      isGridExpanded: '=',
      skipRowSelectionEvent: '=',
      // Height is determined by CSS styling only
      cssHeightOnly: '='
    },
    link: function link(scope, element) {
      var jqxGridElement = element.find('[jqx-settings]');
      scope.$watch('rowDetails', function (newValue) {
        if (newValue === 'true') {
          initRowDetails(element.find('.panel-body').height());
        }
      });
      scope.$watch(function () {
        return element.is(':visible');
      }, function (newValue) {
        if (newValue) {
          scope.setGridVisibilityState(newValue);
        }
      });
      scope.$watch('isGridExpanded', function () {
        if (scope.jqxGridSettings && scope.jqxGridSettings.jqxGrid) {
          scope.$broadcast('grid:refresh:' + scope.gridId);
        }
      });
      function initRowDetails(gridHeight) {
        if (!scope.rowDetailsTemplate) {
          return;
        }
        scope.asyncGridApply('rowdetails', true).then(function () {
          var rowsHeight = scope.jqxGridSettings.jqxGrid('rowsheight');
          var rowDetailsHeight = scope.rowDetailsCalculateHeight ? scope.rowDetailsCalculateHeight(scope, gridHeight, rowsHeight) : gridHeight - 4 * rowsHeight;
          if (rowDetailsHeight < 0) {
            rowDetailsHeight = 100;
          }
          scope.jqxGridSettings.jqxGrid('initrowdetails', function (index, parentElement, gridElement, datarecord) {
            var rowScope = $rootScope.$new();
            rowScope.rowData = datarecord;
            var element = angular.element(scope.rowDetailsTemplate);
            $compile(element)(rowScope);
            rowScope.$apply();
            angular.element(parentElement).css({
              marginLeft: 0
            });
            angular.element(parentElement).find('.rm-row-details-container').css({
              height: rowDetailsHeight
            }).append(element);
          });
          scope.jqxGridSettings.jqxGrid('rowdetailstemplate', {
            rowdetails: '<div class="rm-row-details-container"></div>',
            rowdetailsheight: rowDetailsHeight,
            rowdetailshidden: true
          });
        });
      }
      function resetColumnsSortDirection() {
        scope.asyncGridApply('columns').then(function (gridColumns) {
          if (gridColumns === undefined || gridColumns.records === undefined) {
            return;
          }
          gridColumns.records.forEach(function (sortColumn) {
            updateColumnSortAriaAttributes(sortColumn.element, 'none');
            element.find(sortColumn.sortasc).hide();
            element.find(sortColumn.sortdesc).hide();
          });
        });
      }
      function updateColumnSortDisplay(columnSortData) {
        scope.asyncGridApply('getcolumn', columnSortData.field).then(function (sortColumn) {
          if (sortColumn) {
            if (columnSortData.sortDirection.ascending) {
              updateColumnSortAriaAttributes(sortColumn.element, 'ascending');
              $(sortColumn.sortasc).show();
              $(sortColumn.sortdesc).hide();
            } else {
              updateColumnSortAriaAttributes(sortColumn.element, 'descending');
              $(sortColumn.sortasc).hide();
              $(sortColumn.sortdesc).show();
            }
          }
        });
      }
      function updateColumnSortAriaAttributes(element, direction) {
        angular.element.jqx.aria(element, 'aria-sort', direction);
      }
      function updateColumnSortDirection(sortCriteria) {
        sortCriteria.getActiveSortColumns().forEach(function (column) {
          updateColumnSortDisplay(column);
        });
      }
      element.on('sort', function (event) {
        scope.clearSortingIndicators();
        scope.clearExpandedRowDetails();
        resetColumnsSortDirection();
        var latestSortCriteria = LatestSortService.getLatestSortCriteria(scope.gridId);
        if (event.args.sortinformation.sortcolumn === null || latestSortCriteria === undefined || latestSortCriteria.getActiveSortColumns().length === 0) {
          latestSortCriteria = scope.getDefaultSortCriteria();
        }
        if (!scope.isDefaultSort(latestSortCriteria)) {
          updateColumnSortDirection(latestSortCriteria);
        }
        scope.fireGridSorted(latestSortCriteria);
        scope.setShowSortMenuItems(!latestSortCriteria.isCustomSort());
        scope.setShowSortColumnBackground(!latestSortCriteria.isCustomSort());
        scope.fireGridDataUpdated();
      });
      element.on('filter', function (event) {
        scope.clearExpandedRowDetails();
        scope.updateFilteringState(event.args.filters);
        angularHelper.triggerDigest(scope);
        scope.unselectFilteredOutRows();
      });
      element.on('rowselect', scope.rowSelectionChanged);
      element.on('rowunselect', scope.rowSelectionChanged);
      element.on('celldoubleclick', scope.onGridCellDoubleClick);
      element.on('cellendedit', scope.cellEndEditHandler);
      element.on('rowexpand', scope.rowExpandHandler);
      element.on('cellvaluechanged', scope.cellValueChanged);
      jqxGridElement.on('cellclick', scope.onGridCellClick);
      function triggerCellAction(eventName, originalEvent) {
        var $element = $(originalEvent.currentTarget);
        var uid = $element.attr('uid');
        var fieldId = $element.attr('field-id');
        //this data is needed to show tooltip for cell (or icon)
        var targetPosition = {
          offset: $element.offset(),
          height: $element.height(),
          width: $element.width(),
          mouse: {
            pageX: originalEvent.pageX,
            pageY: originalEvent.pageY
          }
        };
        var dataObject = {
          targetPosition: targetPosition,
          fieldId: fieldId,
          gridId: scope.gridId
        };
        scope.asyncGridApply('getrowdata', uid).then(function (row) {
          dataObject.entityData = row;
          scope.$emit(eventName, dataObject);
        });
      }
      element.on('click', '[data-click="true"]', function (event) {
        triggerCellAction('grid:icon-click', event);
      });
      element.on('mouseenter', '[data-hover="true"]', function (event) {
        triggerCellAction('grid:icon-mouseenter', event);
      });
      element.on('mouseleave', '[data-hover="true"]', function (event) {
        triggerCellAction('grid:icon-mouseleave', event);
      });
      scope.dynamicColumnsReSort = typeof scope.dynamicColumnsReSort === 'undefined' ? true : scope.dynamicColumnsReSort;
      scope.$on('collapsable-panel-trigger', function (event, isVisible) {
        scope.setGridVisibilityState(isVisible);
      });
      if (scope.visibleOffset && scope.visibleOffsetRowHeight) {
        jqxGridElement.on('cellbeginedit', function (evt) {
          if ($window.pageYOffset > scope.visibleOffset) {
            var scrollFromRowIndex = Math.ceil(($window.pageYOffset - 50 - scope.visibleOffset) / scope.visibleOffsetRowHeight);
            if (evt.args.rowindex < scrollFromRowIndex) {
              $window.scrollBy(0, -scope.visibleOffsetRowHeight);
            }
          }
        });
      }
    }
  };
};
GridPanelDirective.$inject = ['JQXGridCustomSortService', 'SortCriteriaFactory', 'JQXGridLatestSortService', 'AngularHelper', '$compile', '$rootScope', '$window'];
module.exports = GridPanelDirective;